import React, { useState, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import eventEmitter from "../events/eventEmitter";
import api from "../helper/api";
import { toast } from "react-toastify";

import play from "../assets/images/svgs/play1.svg";
import casino1 from "../assets/images/casino-icons/casino121.png";
import casino2 from "../assets/images/casino-icons/casino122.png";
import casino3 from "../assets/images/casino-icons/casino123.png";
import casino4 from "../assets/images/casino-icons/casino124.png";
import casino5 from "../assets/images/casino-icons/casino125.png";
import casino6 from "../assets/images/casino-icons/casino126.png";
import casino7 from "../assets/images/casino-icons/casino127.png";
import Notes from "../assets/images/bet-frenzy/image.png";
import { addGameFavorite } from "../redux/slices/games/gameFavorite/addGameFavoriteSlice";
import { removeGameFavorite } from "../redux/slices/games/gameFavorite/removeGameFavoriteSlice";
import PlayModePopup from "./common/PlayModePopup";
import { favoriteGameList } from "../redux/slices/games/gameFavorite/favoriteGameListSlice";

const bgImages = [
  casino1,
  casino2,
  casino3,
  casino4,
  casino5,
  casino6,
  casino7,
];
const CasinoGameGrid = ({
  games,
  favSelect,
  totalGames,
  onShowMore,
  onFavClick,
  loading,
  isMobile,
  params,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [popupOpen, setPopupOpen] = useState(false);
  const [selectedGame, setSelectedGame] = useState(null);
  const [loadingGameId, setLoadingGameId] = useState(null);
  const [prefetchedPopupData, setPrefetchedPopupData] = useState(null);

  const { data: profileData } = useSelector((state) => state.getProfile);
  const [favGames, setFavGames] = useState([]);

  useEffect(() => {
    if (profileData) {
      fetchFavs();
    }
  }, [dispatch, profileData]);
  const fetchFavs = async () => {
    try {
      const payload = {
        page: 1,
        perPage: 10,
        search: "favourite",
      };
      const res = await dispatch(favoriteGameList(payload)).unwrap();
      setFavGames(res?.data || []);
    } catch (error) {
      console.error("Failed to fetch favorites:", error);
    }
  };

  const gamesWithBg = useMemo(() => {
    if (!games?.length) return [];

    return games.map((game) => {
      const isFav = favGames.some(
        (fav) => fav?.game_id_main == game?.game_id_main
      );

      return {
        ...game,
        bg: bgImages[Math.floor(Math.random() * bgImages.length)],
        favourite: isFav,
      };
    });
  }, [games, favSelect]);

  const [gamesWithBg1, setGamesWithBg1] = useState(gamesWithBg);

  useEffect(() => {
    const validatedGames = games?.map((game) => {
      const isFav = favGames.some(
        (fav) => fav?.game_id_main == game?.game_id_main
      );

      return {
        ...game,
        favourite: favSelect || isFav,
        isBroken: false,
      };
    });

    if (validatedGames?.length > 0) {
      validatedGames?.forEach((game, idx) => {
        const img = new Image();
        img.src = game?.url_thumb;

        // Check if the image URL is "no_thumb", and clear the source
        if (game?.url_thumb === "no_thumb") {
          img.src = ""; // Empty source when no thumbnail
        }

        // Check if the image loads successfully
        img.onload = () => {
          setGamesWithBg1((prev) => {
            const copy = [...prev];
            copy[idx] = {
              ...game,
              isBroken: false,
              bg: bgImages[Math.floor(Math.random() * bgImages.length)],
            };
            return copy;
          });
        };

        // Handle broken image (when the image fails to load)
        img.onerror = () => {
          setGamesWithBg1((prev) => {
            const copy = [...prev];
            copy[idx] = {
              ...game,
              isBroken: true,
              bg: bgImages[Math.floor(Math.random() * bgImages.length)],
            };
            return copy;
          });
        };
      });
    } else {
      setGamesWithBg1([]);
    }
  }, [games]);

  useEffect(() => {
    if (favGames.length > 0) {
      setGamesWithBg1((prev) =>
        prev.map((game) => {
          const isFav = favGames.some(
            (fav) => fav?.game_id_main == game?.game_id_main
          );
          return { ...game, favourite: isFav };
        })
      );
    }
  }, [favGames]);

  const handleRemoveFavGlobal = (id, gameIdMain) => {
    const payload = { game_id: gameIdMain || id };

    setFavGames((prev) =>
      prev.filter((game) => game.game_id_main != (gameIdMain || id))
    );

    dispatch(removeGameFavorite(payload))
      .unwrap()
      .then((res) => {
        setGamesWithBg1((prev) =>
          prev.map((game) =>
            game?._id == id ? { ...game, favourite: false } : game
          )
        );
      })
      .catch((error) => {
        console.error("Failed :", error);
        if (gameIdMain || id) {
          setFavGames((prev) => [...prev, { game_id_main: gameIdMain || id }]);
        }
      });
  };

  const handleRemoveFavFromView = (id, gameIdMain) => {
    const payload = { game_id: gameIdMain || id };

    setFavGames((prev) =>
      prev.filter((game) => game.game_id_main != (gameIdMain || id))
    );
    // Remove from UI immediately in Favorite View
    setGamesWithBg1((prev) => prev.filter((game) => game?._id !== id));

    dispatch(removeGameFavorite(payload))
      .unwrap()
      // .then((res) => {
      //   // Success - UI already updated
      // })
      .catch((error) => {
        console.error("Failed :", error);
        // Revert if failed
        if (gameIdMain || id) {
          setFavGames((prev) => [...prev, { game_id_main: gameIdMain || id }]);
        }
        // Ideally we should add it back to gamesWithBg1 too but logic is complex without fetching
        fetchFavs();
      });
  };

  const handleFav = (id) => {
    // Optimistic update for adding favorite
    setGamesWithBg1((prev) =>
      prev.map((game) =>
        game?.game_id_main == id ? { ...game, favourite: true } : game
      )
    );
    setFavGames((prev) => [...prev, { game_id_main: id }]);

    const payload = { game_id: id };
    dispatch(addGameFavorite(payload))
      .unwrap()
      .then((res) => {
        // fetchFavs();
      })
      .catch((error) => {
        console.error("Failed :", error);
        // Revert optimistic update on failure
        setGamesWithBg1((prev) =>
          prev.map((game) =>
            game?.game_id_main == id ? { ...game, favourite: false } : game
          )
        );
        setFavGames((prev) => prev.filter((game) => game.game_id_main != id));
      });
  };
  const handleGameClick = async (game) => {
    if (loadingGameId) return; // Prevent double clicks
    if (!profileData) {
      eventEmitter.emit("openLogin");
      return;
    }

    setLoadingGameId(game?.game_id_main);
    setPrefetchedPopupData(null); // Reset prev data

    try {
      const res = await api.post("/gift/get-risk-free-bets", {
        game_id: game?._id,
      });

      const userData = res?.data;
      const isKYCVerified =
        userData?.user?.is_kyc_verified == "verified" ? true : false;
      const giftWallet = userData?.user?.gift_wallet || 0;
      const hasRiskFreeBet = userData?.hasValidRiskFreeBet;

      // Decision Logic
      if (
        !isKYCVerified ||
        giftWallet > 0 ||
        (hasRiskFreeBet && game?.game_id != "550000") // 550000 check from Popup logic
      ) {
        // Needs interaction -> Open Popup
        setPrefetchedPopupData(userData);
        setSelectedGame(game);
        setPopupOpen(true);
      } else {
        console.log("handlePlayDirectly");
        // Direct Launch (Normal Mode)
        setSelectedGame(game); // Ensure selected game is set for handlePlayModeSelect
        // We can call handlePlayModeSelect directly, but it relies on 'selectedGame' state being updated.
        // Or we just call navigate logic directly here or refactor handlePlayModeSelect to accept game.
        // Let's refactor handlePlayModeSelect to accept game argument or use the game object directly here.
        handlePlayDirectly(game, "normal");
      }
    } catch (error) {
      console.log("Game Launch Check Failed:", error);
      // Fallback: Open popup to handle error state or retry
      setSelectedGame(game);
      setPopupOpen(true);
    } finally {
      setLoadingGameId(null);
    }
  };

  const handlePlayDirectly = (game, mode) => {
    console.log("handlePlayDirectly", profileData);
    const gameId = game?.game_id_main;

    const isKYCVerified =
      profileData?.user?.is_kyc_verified == "verified" ? true : false;
    const giftWallet = profileData?.user?.gift_wallet || 0;
    const mainWallet = profileData?.user?.usable_coin_balance || 0;
    if (isKYCVerified && (giftWallet > 0 || mainWallet > 0)) {
      navigate("/game-launch", {
        state: {
          game_id: gameId,
          game: game,
          play_mode: mode,
          params: params,
        },
      });
    } else {
      if (giftWallet <= 0 && mode !== "normal") {
        toast.warn("Insufficient balance to play the game.");
      } else if (mainWallet <= 0 && mode === "normal") {
        toast.warn("Insufficient balance to play the game.");
      }
      setPrefetchedPopupData(profileData);
      setSelectedGame(game);
      setPopupOpen(true);
      return;
    }
  };

  const handlePlayModeSelect = (mode) => {
    setPopupOpen(false);
    if (!selectedGame) return;
    console.log("handlePlayDirectly", mode);
    handlePlayDirectly(selectedGame, mode);
  };
  return (
    <>
      <div className="games-wrapper">
        {loading ? (
          <div className="casino-grid-no-data" style={{ display: "block" }}>
            <div className="spinner-border text-success " role="status"></div>
          </div>
        ) : gamesWithBg1.length > 0 ? (
          <>
            <ul className="games">
              {gamesWithBg1 &&
                gamesWithBg1?.map((game, index) => (
                  <li key={game?.game_id_main} className="games-list">
                    {/* <p>{game.game_id}</p> */}
                    <div
                      className={`bg ${
                        game?.isBroken
                          ? `broken-image gradient-${index % 6}`
                          : ""
                      }`}
                      style={{
                        backgroundImage: game?.isBroken
                          ? undefined
                          : `url("${game?.url_thumb}")`,
                      }}
                    >
                      {/* Game name always visible for broken images */}
                      {game?.isBroken && (
                        <div className="game-name-fallback">
                          <span className="game-name-text">
                            {game?.game_name}
                          </span>
                        </div>
                      )}

                      <div className="slot-hover">
                        {loadingGameId === game?.game_id_main ? (
                          <div className="d-flex justify-content-center align-items-center w-100 h-100">
                            <div
                              className="spinner-border text-white"
                              role="status"
                              style={{ width: "30px", height: "30px" }}
                            ></div>
                          </div>
                        ) : (
                          <img
                            loading="lazy"
                            className="play"
                            src={play}
                            draggable={false}
                            alt="play icon"
                            width={window.innerWidth > 768 ? 50 : 30}
                            height={window.innerWidth > 768 ? 50 : 30}
                            onClick={() => handleGameClick(game)}
                          />
                        )}

                        <div className="star-wrapper">
                          <span
                            className="material-icons cursor-pointer"
                            onClick={(e) => {
                              e.stopPropagation();
                              if (profileData) {
                                if (game?.favourite) {
                                  if (favSelect) {
                                    handleRemoveFavFromView(
                                      game?._id,
                                      game?.game_id_main
                                    );
                                  } else {
                                    handleRemoveFavGlobal(
                                      game?._id,
                                      game?.game_id_main
                                    );
                                  }
                                } else {
                                  handleFav(game?.game_id_main);
                                }
                              } else {
                                navigate("/");
                                sessionStorage.setItem("fromLogin", "true");
                              }
                            }}
                          >
                            {!game?.favourite ? (
                              <svg
                                width="24"
                                height="22"
                                viewBox="0 0 24 22"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12 21.6648C11.6583 21.6648 11.3289 21.541 11.0722 21.3162C10.1026 20.4684 9.16789 19.6717 8.34318 18.9689L8.33897 18.9653C5.92107 16.9048 3.83312 15.1254 2.38037 13.3725C0.756407 11.4129 0 9.55493 0 7.52521C0 5.55316 0.676207 3.73383 1.90393 2.4021C3.1463 1.05463 4.851 0.3125 6.70458 0.3125C8.08995 0.3125 9.35869 0.750488 10.4754 1.6142C11.039 2.05017 11.5499 2.58374 12 3.20612C12.4502 2.58374 12.9609 2.05017 13.5247 1.6142C14.6415 0.750488 15.9102 0.3125 17.2956 0.3125C19.149 0.3125 20.8538 1.05463 22.0962 2.4021C23.3239 3.73383 24 5.55316 24 7.52521C24 9.55493 23.2437 11.4129 21.6198 13.3723C20.167 15.1254 18.0793 16.9046 15.6617 18.9649C14.8355 19.6688 13.8993 20.4667 12.9276 21.3165C12.6711 21.541 12.3415 21.6648 12 21.6648ZM6.70458 1.71838C5.24834 1.71838 3.91058 2.29956 2.93737 3.35498C1.9497 4.42633 1.4057 5.90729 1.4057 7.52521C1.4057 9.2323 2.04016 10.759 3.4627 12.4755C4.83764 14.1346 6.88274 15.8774 9.25065 17.8954L9.25505 17.899C10.0829 18.6046 11.0213 19.4044 11.998 20.2584C12.9805 19.4027 13.9204 18.6016 14.7499 17.895C17.1176 15.877 19.1625 14.1346 20.5374 12.4755C21.9598 10.759 22.5943 9.2323 22.5943 7.52521C22.5943 5.90729 22.0503 4.42633 21.0626 3.35498C20.0896 2.29956 18.7516 1.71838 17.2956 1.71838C16.2288 1.71838 15.2494 2.0575 14.3846 2.7262C13.6139 3.32239 13.077 4.07605 12.7622 4.60339C12.6004 4.87457 12.3155 5.03644 12 5.03644C11.6845 5.03644 11.3996 4.87457 11.2377 4.60339C10.9231 4.07605 10.3863 3.32239 9.6154 2.7262C8.75059 2.0575 7.77116 1.71838 6.70458 1.71838Z"
                                  fill="white"
                                />
                              </svg>
                            ) : (
                              <>
                                <svg
                                  width="24"
                                  height="22"
                                  viewBox="0 0 24 22"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M12 21.6648C11.6583 21.6648 11.3289 21.541 11.0722 21.3162C10.1026 20.4684 9.16789 19.6717 8.34318 18.9689L8.33897 18.9653C5.92107 16.9048 3.83312 15.1254 2.38037 13.3725C0.756407 11.4129 0 9.55493 0 7.52521C0 5.55316 0.676207 3.73383 1.90393 2.4021C3.1463 1.05463 4.851 0.3125 6.70458 0.3125C8.08995 0.3125 9.35869 0.750488 10.4754 1.6142C11.039 2.05017 11.5499 2.58374 12 3.20612C12.4502 2.58374 12.9609 2.05017 13.5247 1.6142C14.6415 0.750488 15.9102 0.3125 17.2956 0.3125C19.149 0.3125 20.8538 1.05463 22.0962 2.4021C23.3239 3.73383 24 5.55316 24 7.52521C24 9.55493 23.2437 11.4129 21.6198 13.3723C20.167 15.1254 18.0793 16.9046 15.6617 18.9649C14.8355 19.6688 13.8993 20.4667 12.9276 21.3165C12.6711 21.541 12.3415 21.6648 12 21.6648Z"
                                    fill="red"
                                  />
                                </svg>
                              </>
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                  </li>
                ))}
            </ul>
            {loading && isMobile && (
              <div className="loader-center p-3">
                <div className="loading-dots">
                  <div className="dot bg-light"></div>
                  <div className="dot bg-light"></div>
                  <div className="dot bg-light"></div>
                </div>
              </div>
            )}
          </>
        ) : (
          <div className="casino-grid-no-data" style={{ display: "block" }}>
            <img
              loading="lazy"
              draggable={false}
              className="casino-no-data-image"
              src={Notes}
              alt="no-data"
            />
            <div className="text pb-3" text_key="CASINO__NO_GAMES">
              No Games
            </div>
          </div>
        )}
        {!isMobile && (
          <>
            <div className="loaded-visible">
              <div className="text-wrapper">
                <span id="rendered-count">{games?.length}</span>{" "}
                <span className="of">OF</span>{" "}
                <span id="games-count">{totalGames}</span>
              </div>
              <div className="progress-bar">
                <div
                  className="line"
                  style={{ width: `${(games?.length / totalGames) * 100}%` }}
                ></div>
              </div>
            </div>
            {games.length < totalGames && (
              <div
                className="show-more btn solid visible "
                onClick={onShowMore}
              >
                Show more
              </div>
            )}
          </>
        )}
      </div>
      {popupOpen && selectedGame && (
        <PlayModePopup
          isOpen={popupOpen}
          onClose={() => setPopupOpen(false)}
          onSelect={handlePlayModeSelect}
          selectedGame={selectedGame}
          prefetchedData={prefetchedPopupData}
        />
      )}
    </>
  );
};

CasinoGameGrid.propTypes = {
  games: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      image: PropTypes.string.isRequired,
    })
  ).isRequired,
  totalGames: PropTypes.number.isRequired,
  onShowMore: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

export default CasinoGameGrid;
